import React from 'react';
import { FiCalendar } from 'react-icons/fi';
import '../Team/Work.css'; // We'll create this CSS file next

const WorkSection = () => {
  const workItems = [
    {
      title: 'Night Live Concert',
      description: 'Full-scale production featuring top playback singers with pyrotechnics, LED walls, and immersive sound design for audience',
      date: 'June 2023',
      image: '/singer.JPG',
      tag: 'Live Concert 🎤',
      details: [
        'Line-up of celebrity singers',
        'non-stop musical experience',
        'Custom stage spanning feet',
        'Professional lighting and laser show',
        'Crowd management for attendees'
      ]
    },
    {
      title: 'IQA International Quality Awards',
      description: 'Prestigious award ceremony recognizing excellence in quality standards across industries',
      date: 'September 2023',
      image: '/iqa.png',
      tag: 'Award Ceremonies 🏆',
      details: [
        'industry professionals and dignitaries',
        'Recognition across quality categories',
        'Keynote speech by international quality experts',
        'Yellow theme and media interaction zone',
        'Open Sky and award distribution'
      ]
    },
    {
      title: 'Medtronic Healthcare Technologies Seminar',
      description: 'Corporate seminar highlighting of Medtronic latest innovations in medical technologies and patient care solutions',
      date: 'January 2024',
      image: '/medtronic.JPG',
      tag: 'Corporate Events 🏢',
      details: [
        'Industry presentations on cutting-edge medical devices',
        'Live demos of breakthrough healthcare technologies',
        'Panel discussion with leading doctors and researchers',
        'Q&A sessions with Medtronic product specialists',
        'Networking lunch with healthcare professionals'
      ]
    },
    {
      title: 'New Education Policy Seminar',
      description: 'Insightful seminar on NEP reforms conducted by Vision IAS for aspirants and educators',
      date: 'April 2024',
      image: '/s3.jpg',
      tag: 'Educational Events 📘',
      details: [
        'participants including educators and students',
        'Expert sessions on NEP reforms',
        'Interactive Q&A with Vision IAS faculty',
        'Distribution of NEP-focused study material',
        'Panel discussion with education policy analysts'
      ]
    },
    {
      title: 'Abacus & Mental Arithmetic Competition',
      description: 'Annual UCMAS competition showcasing speed and accuracy in mental math among young learners',
      date: 'October 2024',
      image: '/ucmas.png',
      tag: 'Academic Competitions 🧠',
      details: [
        'student participants from across the state',
        'Live mental math challenges',
        'Timed abacus speed tests',
        'Award ceremony with certificates and trophies',
        'Parent and coach engagement zones'
      ]
    },
    {
      title: 'Sharma Family Wedding Celebration',
      description: 'Grand multi-day wedding celebration filled with tradition, joy, and elegance',
      date: 'February 2025',
      image: '/marriage.png',
      tag: 'Wedding Event 💍',
      details: [
        'Traditional Haldi, Mehendi, and Sangeet ceremonies',
        'guests with luxury accommodations',
        'Designer decor and themed floral arrangements',
        'Live music and dance performances',
        'Lavish multi-cuisine catering and dessert bars'
      ]
    }
  ];
  
    return (
      <section className="work-section-w">
        <div className="container-w">
          <h2 className="section-title-w">Moments Crafted by <br/><span className='section-title-w-span'>श्री Var Event & Conference</span> </h2>
          
          <div className="work-grid-w">
            {workItems.map((item, index) => (
              <div 
                key={item.id} 
                className={`work-item-w ${index === 0 ? 'large-w' : index < 3 ? 'medium-w' : 'small-w'}`}
              >
                <div className="work-image-container-w">
                  <img 
                    src={item.image} 
                    alt={item.title} 
                     loading="lazy" 
                    className="work-image-w"
                  />
                  <div className="image-overlay-w">
                    <span className="work-tag-w">{item.tag}</span>
                  </div>
                </div>
                <div className="work-content-w">
                  <h3 className="work-title-w">{item.title}</h3>
                  <p className="work-description-w">{item.description}</p>
                  <div className="work-details-w">
                    <ul className="details-list-w">
                      {item.details.map((detail, i) => (
                        <li key={i} className="detail-item-w">{detail}</li>
                      ))}
                    </ul>
                  </div>
                  <div className="work-date-w">
                    <FiCalendar className="calendar-icon-w" />
                    <span>{item.date}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  };
  
  export default WorkSection;